import { Toast } from 'primereact/toast';
import { MutableRefObject } from 'react';

export const showSuccessMessage = (
  toast: MutableRefObject<Toast | null>,
  detail: string,
  summary: string = 'Éxito',
) => {
  toast.current?.show({
    severity: 'success',
    summary,
    detail,
    life: 3000,
  });
};

export const showErrorMessage = (
  toast: MutableRefObject<Toast | null>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any,
  fallback: string = 'There was an error processing your request',
  summary: string = 'Error',
) => {
  const detail = error?.response?.data?.errors?.[0] || error?.message || fallback;

  toast.current?.show({
    severity: 'error',
    summary,
    detail,
    life: 4000,
  });
};
